import { useCallback, useEffect, useRef } from 'react'

export default function useTimeout(callback, delay = 1e3) {
  const callbackRef = useRef(callback)
  const timeoutRef = useRef()

  const set = useCallback(() => {
    timeoutRef.current = setTimeout(callbackRef.current, delay)
  }, [delay])

  const clear = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current)
  }, [])

  const reset = useCallback(() => {
    clear()
    set()
  }, [clear, set])

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    set()
    return clear
  }, [delay, set, clear])

  return { reset, clear }
}
